import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Avatar, Box, Button, Modal } from '@mui/material'
import { ReactComponent as QrButton } from '../../../../Assets/img/icons/qr-button-figma.svg'
import { ReactComponent as Wave } from '../../../../Assets/img/card/wave-only-big.svg'
import { MdOutlinePhoneIphone } from "react-icons/md";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import Visa from '../../../.././Assets/img/logo (1).png';
import { useUserDetailContext } from '../../../UserDetailContext'

import chip from '../../../.././Assets/img/icons/chip.png';
import QrCodeCard, { QrCodeVisitingCard } from '../../Cards/QrCodeCard';
import { color } from 'framer-motion'
import { useCardDetailContext } from '../../../CardDetailContext'
import { useCreateCardDetailContext } from '../../../CreatecardDetailContext'
import { captureConsoleIntegration } from '@sentry/react'
import cardbg from '../../../../Assets/img/cardBg.webp';
import Neoin_logo from '../../../../Assets/img/Neoin-logo.png';
import Visa from '../../../../Assets/img/VisaIcon.svg';
import DefalutLogo from '../../../../Assets/img/logo-placeholder.jpg';

const VisitingCard = ({ cardDetails, cardQrstyles, cardContacts, activeProfile, isOwner }) => {
    // const objectId = localStorage.getItem("objectId");
    const navigate = useNavigate();
    const { updateCardDetails, updateSocialLinks2, updateCardStyles, updateCardQrStyles, updateContactStyles, updateAttachDocsVal } = useCreateCardDetailContext();
    const { userDetails } = useUserDetailContext();

    const [qrDialogueOpen, setQrDialogueOpen] = useState(false);
    const [showCreateCard, setShowCreateCard] = useState(false);
    const [NewCardType, setNewCardType] = useState('');
    const [chooseCategory, setchooseCategory] = useState(false);

    const [firstName, lastName] = userDetails.name.split(' ');
    useEffect(() => {
        // Check if professional card data is empty when the active profile is 'professional_profile'
        if (activeProfile === 'professional_profile' && !cardDetails?.firstName) {
            // console.log("cardDetails ---->", cardDetails);
            setShowCreateCard(true);
        } else {
            setShowCreateCard(false);
        }
    }, [activeProfile, cardDetails]);

    const handleOpenDialog = (event) => {
        event.preventDefault();
        setQrDialogueOpen(true);
        // console.log('handleOpenDialog clicked!')
    };

    const handleCloseDialogue = () => {
        setQrDialogueOpen(false);
    };

    const phoneNumber = cardContacts?.mobile_number ? cardContacts?.mobile_number?.replace(/\s+/g, "") : cardDetails?.defaultPhone;
    const emailId = cardContacts?.email ? cardContacts?.email : cardDetails?.defaultEmail;
    const whatsappNumber = cardContacts?.whatsapp ? cardContacts?.whatsapp?.replace(/\s+/g, "") : cardDetails?.defaultPhone;

    const cardName = cardDetails?.cardName;

    // console.log('Card Contacts: ', cardContacts);

    if ((!cardDetails || Object.keys(cardDetails).length === 0) && !isOwner) { // Don't show anything if professional card is not present AND if the viewer is not the owner of the card too
        return (
            <> </>
        )
    }

    // const { cards } = useCardDetailContext();

    const handleCardTypeClick = (category) => {
        console.log("Category :", category);
        setNewCardType(category);
        updateCardDetails({ "CardType": category });
        updateCardStyles({ "CardType": category });
        if (category === "Customize_Personal") {
            updateCardStyles({ "layoutStyle": '2' }); //For Personal Card - Default Layout is 2
        }
        updateCardQrStyles({ "CardType": category });
        updateSocialLinks2({ "card_type": category });
        updateContactStyles({ "card_type": category, mobile_number: userDetails.phone, email: userDetails.email });
        updateAttachDocsVal({ fieldName: "card_name", value: category }); // It is Needed If CardType is GenZ itself
        setchooseCategory(false);
        // setChooseCustomizeCategory(false);
        // setIsPersonalDetailsSaved(false);
        navigate('/create-card', { state: { category: category } });
    };
    // console.log("CARd Details in the Visiting card", cardDetails);
    return (
        <>
            {(activeProfile === 'personal_profile' || activeProfile === 'professional_profile') &&
                <Box className="sidefeed-box profile-visiting-card">
                    <div id='Card-firstPart-createNew'>
                        <div className="visiting-card-content">
                            <div className="visiting-card-upper" style={{ position: "relative" }}>
                                <div className="qr-button pointer flex-center" onClick={handleOpenDialog}>
                                    <QrButton />
                                </div>
                                <div className="profile-pic-container">
                                    <Avatar sx={{ height: '5.5rem', width: '5.5rem' }}>
                                        {cardDetails?.profile_pic &&
                                            <img src={cardDetails?.profile_pic} alt={cardDetails?.firstName} className='circle-image' />
                                        }
                                    </Avatar>
                                </div>
                                <div className="name-and-profession word-break">
                                    <div className='visiting-card-name'>{cardDetails?.firstName} {cardDetails?.lastName}</div>
                                    {activeProfile === 'professional_profile' &&
                                        <div>
                                            {cardDetails?.company} {cardDetails?.company && cardDetails?.designation ? ' - ' : ''} {cardDetails?.designation}
                                        </div>
                                    }
                                    {activeProfile === 'personal_profile' &&
                                        <div>
                                            {cardDetails?.title}
                                        </div>
                                    }
                                </div>
                                <Wave style={{ position: "absolute", bottom: "-2.75rem", width: "100%", left: 0 }} />
                                <div className='company-logo-container flex-column flex-center'>
                                    <div className={`company-logo-div flex-center mb-2 ${activeProfile !== 'professional_profile' || cardDetails.logo === '' ? 'v-hidden' : ''}`}>
                                        <img src={cardDetails?.logo ? cardDetails?.logo : DefalutLogo} alt="Company" className='prof-company-logo' />
                                    </div>
                                    <div className='visiting-card-type'>{activeProfile === 'professional_profile' ? 'Business Card' : 'Personal Card'}</div>
                                </div>
                            </div>
                            <div className="visiting-card-lower">
                                <div className='quick-link-container'>
                                    {(cardContacts?.call_visible) && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`tel:${phoneNumber}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0'><MdOutlinePhoneIphone className='icon-color3' /></div>
                                            </a>
                                        </div>)}
                                    {(cardContacts?.sms_visible) && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`sms:${phoneNumber}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0'><SmsIcon className='icon-color3' /></div>
                                            </a>
                                        </div>)}
                                    {(cardContacts?.email_visible) && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`mailto:${emailId}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0'><EmailIcon className='icon-color3' /></div>
                                            </a>
                                        </div>)}
                                    {(cardContacts?.whatsapp_visible) && (
                                        <div className='flex-center flex-column quick-link-icon'>
                                            <a className='flex-center flex-column' href={`https://wa.me/${whatsappNumber}`} target='_blank' rel='noreferrer'>
                                                <div className='icon icon-outside contact-icon-shadow m-0'><WhatsappFilled className='icon-color3' /></div>
                                            </a>
                                        </div>)}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="dialogue-overlay" style={{ display: qrDialogueOpen ? 'flex' : 'none' }} onClick={handleCloseDialogue}>
                        <div className='qr-close-icon pointer' onClick={handleCloseDialogue}>
                            <CloseRoundedIcon />
                        </div>
                        <div className='Scanner-outline-preview'>
                            <Link
                                to={`${process.env.REACT_APP_CARD_URL}/digital-identity/${cardName}/${cardDetails?.token}`}
                                target='_blank'
                                rel='noreferrer'
                            >
                                <div className='Displaying-QR'>
                                    {/* <QrCodeCard id={cardName} size={150} /> */}
                                    <QrCodeVisitingCard cardDetails={cardDetails} CardQrStyles={cardQrstyles} />
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="dialogue-overlay" style={{ display: showCreateCard ? 'flex' : 'none' }}>
                        <Box className='dialogue-overlay-box-small text-center'>
                            <h6>Create your Professional Card to display a Visiting Card Here!</h6>
                            {/* <Link
                                to={isOwner ? "/edit-card" : "#"}
                                onClick={(e) => {
                                    if (!isOwner) e.preventDefault(); // Prevent navigation
                                }}
                                rel="noreferrer"
                            > */}
                            <Button variant="contained" sx={{ backgroundColor: "#0044C6", margin: "12px 0" }} disabled={isOwner === false} onClick={() => handleCardTypeClick('Professional')}>
                                Create Card
                            </Button>
                            {/* </Link> */}
                        </Box>
                    </div>


                    {/* <QrCodeDialog cardType={cardName} dialogOpen={qrDialogueOpen} handleCloseDialog={handleCloseDialogue} /> */}
                </Box>

            }
            {(activeProfile === 'finance' || activeProfile === 'ppf_score') &&

                <div style={{
                    position: 'relative',
                    width: '380px',
                    height: '150px',
                    borderRadius: '5px',
                    overflow: 'hidden',
                    backgroundColor: 'rgb(54, 69, 79)'
                }}>
                    <img
                        src={cardbg}
                        alt="cardbg"
                        style={{ width: '100%', height: '100%', objectFit: 'cover', backgroundColor: "rgb(54, 69, 79)" }}
                    />

                    <p className="ps-2 pe-4 py-1" style={{
                        position: 'absolute',
                        top: '15px',
                        // left: '10px',
                        color: '#fff',
                        backgroundColor: "#0044c6",
                        borderTopRightRadius: "18px",
                        borderBottomRightRadius: "18px",
                        // fontWeight: 'bold'
                        fontSize: "14px"
                    }}>Financial</p>


                    <img
                        src={Neoin_logo}
                        alt="neoinlogo"
                        style={{
                            position: 'absolute',
                            top: '15px',
                            right: '10px',
                            width: '50px' // adjust as needed
                        }} />


                    <p style={{
                        position: 'absolute',
                        top: '60px',
                        left: '30px',
                        color: '#fff',
                        fontWeight: 'bold'
                    }}>
                        7753 3888 2528 22291
                    </p>
                    <span className='d-flex flex-column' style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '30px',
                        color: '#fff',
                    }}>
                        <span className='financial-card-text1'>Holder Name</span>
                        <span className='financial-card-text2' >{firstName} {lastName}</span>
                    </span>
                    <span className='d-flex flex-column' style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '150px',
                        color: '#fff',
                    }}>
                        <span className='financial-card-text1 ps-1'>Expiry  Date</span>
                        <span className='financial-card-text2'>12/30</span>
                    </span>

                    <span className='ms-3 mt-1' style={{
                        position: 'absolute',
                        bottom: '2px',
                        right: '10px',
                    }}>
                        <img src={Visa} alt="Visa Icon" width={50} height={50} />
                    </span>

                </div>}
        </>
    )
}

export default VisitingCard